import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_order_request_product",
  ref: "orderRequestProductRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-950px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_order_request_product_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-400" }, null, -1)
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "me-n7 pe-7",
  id: "kt_modal_order_request_product_scroll",
  "data-kt-scroll": "false",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_order_request_product_header",
  "data-kt-scroll-wrappers": "#kt_modal_order_request_product_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "d-flex flex-column gap-4" }
const _hoisted_11 = { class: "table align-middle table-row-bordered border-bottom fs-6 gy-5 mb-0" }
const _hoisted_12 = { class: "text-start text-gray-400 fw-bold fs-7 text-nowrap text-uppercase gs-0" }
const _hoisted_13 = { class: "text-start" }
const _hoisted_14 = { class: "text-start" }
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = { class: "text-end" }
const _hoisted_19 = { class: "text-end" }
const _hoisted_20 = { class: "fw-bold text-gray-800" }
const _hoisted_21 = { class: "text-end" }
const _hoisted_22 = { class: "text-end text-nowrap" }
const _hoisted_23 = { class: "text-end" }
const _hoisted_24 = { class: "text-end" }
const _hoisted_25 = { class: "text-end text-nowrap" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  colspan: "6",
  class: "text-center"
}
const _hoisted_28 = {
  key: 0,
  class: "notice d-flex bg-light-warning rounded border-warning border border-dashed p-6 mb-4"
}
const _hoisted_29 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_30 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_31 = { class: "fw-semibold" }
const _hoisted_32 = { class: "text-gray-900" }
const _hoisted_33 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "d-flex align-items-center gap-3" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { class: "svg-icon svg-icon-3" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { class: "svg-icon svg-icon-3" }
const _hoisted_40 = { class: "table align-middle table-row-bordered border-bottom fs-6 gy-5 my-4" }
const _hoisted_41 = { class: "text-start text-gray-400 fw-bold fs-7 text-nowrap text-uppercase gs-0" }
const _hoisted_42 = {
  class: "text-start",
  colspan: "2"
}
const _hoisted_43 = {
  class: "text-start",
  colspan: "3"
}
const _hoisted_44 = { class: "text-end" }
const _hoisted_45 = { class: "text-end" }
const _hoisted_46 = { class: "fw-bold text-gray-800" }
const _hoisted_47 = { class: "text-end" }
const _hoisted_48 = { class: "text-end text-nowrap" }
const _hoisted_49 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = {
  colspan: "6",
  class: "text-center"
}
const _hoisted_52 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { class: "d-flex align-items-center gap-3" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = { class: "svg-icon svg-icon-3" }
const _hoisted_57 = ["disabled"]
const _hoisted_58 = { class: "svg-icon svg-icon-3" }
const _hoisted_59 = { class: "table align-middle table-row-bordered border-bottom fs-6 gy-5 mb-0" }
const _hoisted_60 = { class: "text-start text-gray-400 fw-bold fs-7 text-nowrap text-uppercase gs-0" }
const _hoisted_61 = {
  class: "text-start",
  colspan: "2"
}
const _hoisted_62 = {
  class: "text-start",
  colspan: "3"
}
const _hoisted_63 = { class: "text-end" }
const _hoisted_64 = { class: "text-end text-white user-select-none" }
const _hoisted_65 = { class: "fw-bold text-gray-800" }
const _hoisted_66 = { class: "text-end" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1)
const _hoisted_68 = { key: 0 }
const _hoisted_69 = {
  colspan: "6",
  class: "text-center"
}
const _hoisted_70 = { class: "modal-footer align-items-center justify-content-end gap-2 max-sm-justify-content-center" }
const _hoisted_71 = ["disabled"]
const _hoisted_72 = { class: "svg-icon svg-icon-2x" }
const _hoisted_73 = ["disabled"]
const _hoisted_74 = { class: "svg-icon svg-icon-2x" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_common_product = _resolveComponent("common-product")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", _hoisted_5, [
              _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRequest.confirmModalInform")), 1)
            ]),
            _hoisted_6
          ]),
          _createElementVNode("div", {
            "data-bs-dismiss": "modal",
            class: "btn btn-icon btn-sm btn-active-icon-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
          }, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.t("orderRequest.confirmProduct")), 1),
                    _createElementVNode("table", _hoisted_11, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", _hoisted_12, [
                          _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.t("order.product")), 1),
                          _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.t("order.sku")), 1),
                          _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.t("orderRequest.qtyConf")), 1),
                          _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.t("orderRequest.netPrice")), 1),
                          _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.t("order.discount")), 1),
                          _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.t("order.tax")), 1),
                          _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.t("orderRequest.total")), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", _hoisted_20, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.confirmedProduct, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createVNode(_component_common_product, {
                              gallery: [
                            {
                              id: 0,
                              origin_url: item.__show.product_gallery,
                            },
                          ],
                              brand_id: item.brand_name,
                              brand_article_no: item.article_no,
                              product_identifier_id: 
                            item.__show.product_identifier_id
                          ,
                              source_link: '',
                              name: item.__show.product_name,
                              name_en: item.__show.product_name,
                              color: item.color,
                              size: item.size
                            }, null, 8, ["gallery", "brand_id", "brand_article_no", "product_identifier_id", "name", "name_en", "color", "size"]),
                            _createElementVNode("td", _hoisted_21, [
                              _createElementVNode("span", null, _toDisplayString(item.confirmed_qty), 1)
                            ]),
                            _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.$currency.currency(
                              _ctx.isTaxCount
                                ? item.unit_gross_amount
                                : item.unit_net_amount,
                              2,
                              ",",
                              ".",
                              "€ "
                            )), 1),
                            _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.$currency.currency(item.discount, 2, ",", ".", "")) + _toDisplayString(item.discount_type === _ctx.CurrencyType.Amount
                              ? "€"
                              : "%"), 1),
                            _createElementVNode("td", _hoisted_24, _toDisplayString(item.tax_rate + "%"), 1),
                            _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.$currency.currency(
                              _ctx.getItemAmountTotal(
                                item.confirmed_qty,
                                _ctx.getNetPrice(item),
                                item.discount,
                                item.discount_type,
                                item.tax_rate,
                                false
                              ),
                              2,
                              ",",
                              ".",
                              "€ "
                            )), 1)
                          ]))
                        }), 128)),
                        (_ctx.formData.confirmedProduct.length == 0)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                              _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.t("common.noData")), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _withDirectives(_createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.t("orderRequest.undeterminedProduct")), 1),
                      (!_ctx.formData.isConfirmed)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createElementVNode("span", _hoisted_29, [
                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.t("orderRequest.confirmModalTip")), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_33, [
                          _withDirectives(_createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-primary",
                            disabled: _ctx.loading,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.isEdit = true))
                          }, _toDisplayString(_ctx.t("common.edit")), 9, _hoisted_34), [
                            [_vShow, !_ctx.formData.isEdit]
                          ]),
                          _withDirectives(_createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-icon btn-light",
                                disabled: _ctx.loading,
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmedEditQty(0)))
                              }, [
                                _createElementVNode("span", _hoisted_37, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                                ])
                              ], 8, _hoisted_36),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-icon btn-primary",
                                disabled: _ctx.loading,
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirmedEditQty(1)))
                              }, [
                                _createElementVNode("span", _hoisted_39, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr012.svg" })
                                ])
                              ], 8, _hoisted_38)
                            ])
                          ], 512), [
                            [_vShow, _ctx.formData.isEdit]
                          ])
                        ])
                      ]),
                      _createElementVNode("table", _hoisted_40, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", _hoisted_41, [
                            _createElementVNode("th", _hoisted_42, _toDisplayString(_ctx.t("order.product")), 1),
                            _createElementVNode("th", _hoisted_43, _toDisplayString(_ctx.t("order.sku")), 1),
                            _createElementVNode("th", _hoisted_44, _toDisplayString(_ctx.t("orderRequest.qtyReq")), 1),
                            _createElementVNode("th", _hoisted_45, _toDisplayString(_ctx.t("orderRequest.numberFutureFulfilable")), 1)
                          ])
                        ]),
                        _createElementVNode("tbody", _hoisted_46, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.editProduct, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createVNode(_component_common_product, {
                                gallery: [
                              {
                                id: 0,
                                origin_url: item.__show.product_gallery,
                              },
                            ],
                                brand_id: item.brand_name,
                                brand_article_no: item.article_no,
                                product_identifier_id: 
                              item.__show.product_identifier_id
                            ,
                                source_link: '',
                                name: item.__show.product_name,
                                name_en: item.__show.product_name,
                                color: item.color,
                                size: item.size,
                                skuCol: 3,
                                productCol: 2
                              }, null, 8, ["gallery", "brand_id", "brand_article_no", "product_identifier_id", "name", "name_en", "color", "size"]),
                              _createElementVNode("td", _hoisted_47, _toDisplayString(item.request_qty), 1),
                              _createElementVNode("td", _hoisted_48, [
                                _withDirectives(_createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_49, [
                                    _createVNode(_component_el_form_item, { class: "m-0" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          class: "w-70px size-sm",
                                          modelValue: item.edit_qty,
                                          "onUpdate:modelValue": ($event: any) => ((item.edit_qty) = $event),
                                          placeholder: " "
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_option, {
                                              label: 0,
                                              value: 0
                                            }),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.request_qty, (row, rowIndex) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: rowIndex,
                                                label: row,
                                                value: row
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ])
                                ], 512), [
                                  [_vShow, _ctx.formData.isEdit]
                                ]),
                                _withDirectives(_createElementVNode("div", null, _toDisplayString(item.confirmed_qty), 513), [
                                  [_vShow, !_ctx.formData.isEdit]
                                ])
                              ])
                            ]))
                          }), 128)),
                          (_ctx.formData.editProduct.length == 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_50, [
                                _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.t("common.noData")), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _withDirectives(_createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_52, [
                          _withDirectives(_createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-primary",
                            disabled: _ctx.loading,
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.isEdit = true))
                          }, _toDisplayString(_ctx.t("common.edit")), 9, _hoisted_53), [
                            [_vShow, !_ctx.formData.isEdit]
                          ]),
                          _withDirectives(_createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-icon btn-light",
                                disabled: _ctx.loading,
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmedEditQty(0)))
                              }, [
                                _createElementVNode("span", _hoisted_56, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                                ])
                              ], 8, _hoisted_55),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-icon btn-primary",
                                disabled: _ctx.loading,
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.confirmedEditQty(1)))
                              }, [
                                _createElementVNode("span", _hoisted_58, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr012.svg" })
                                ])
                              ], 8, _hoisted_57)
                            ])
                          ], 512), [
                            [_vShow, _ctx.formData.isEdit]
                          ])
                        ])
                      ], 512), [
                        [_vShow, _ctx.formData.editProduct.length > 5]
                      ])
                    ]),
                    _withDirectives(_createElementVNode("div", null, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.t("orderRequest.rejectedProduct")), 1),
                      _createElementVNode("table", _hoisted_59, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", _hoisted_60, [
                            _createElementVNode("th", _hoisted_61, _toDisplayString(_ctx.t("order.product")), 1),
                            _createElementVNode("th", _hoisted_62, _toDisplayString(_ctx.t("order.sku")), 1),
                            _createElementVNode("th", _hoisted_63, _toDisplayString(_ctx.t("orderRequest.qtyRejected")), 1),
                            _createElementVNode("th", _hoisted_64, _toDisplayString(_ctx.t("orderRequest.numberFutureFulfilable")), 1)
                          ])
                        ]),
                        _createElementVNode("tbody", _hoisted_65, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.rejectedProduct, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createVNode(_component_common_product, {
                                gallery: [
                              {
                                id: 0,
                                origin_url: item.__show.product_gallery,
                              },
                            ],
                                brand_id: item.brand_name,
                                brand_article_no: item.article_no,
                                product_identifier_id: 
                              item.__show.product_identifier_id
                            ,
                                source_link: '',
                                name: item.__show.product_name,
                                name_en: item.__show.product_name,
                                color: item.color,
                                size: item.size,
                                skuCol: 3,
                                productCol: 2
                              }, null, 8, ["gallery", "brand_id", "brand_article_no", "product_identifier_id", "name", "name_en", "color", "size"]),
                              _createElementVNode("td", _hoisted_66, _toDisplayString(item.request_qty), 1),
                              _hoisted_67
                            ]))
                          }), 128)),
                          (_ctx.formData.rejectedProduct.length == 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_68, [
                                _createElementVNode("td", _hoisted_69, _toDisplayString(_ctx.t("common.noData")), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 512), [
                      [_vShow, _ctx.formData.rejectedProduct.length > 0]
                    ])
                  ], 512), [
                    [_vShow, !_ctx.isAllConfirmItems]
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-light",
                disabled: _ctx.loading,
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
              }, [
                _createElementVNode("span", _hoisted_72, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr088.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("orderRequest.cancel")), 1)
              ], 8, _hoisted_71),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                disabled: _ctx.loading || _ctx.formData.isEdit,
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, [
                _createElementVNode("span", _hoisted_74, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr085.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.isAllRejectItems ||
                _ctx.isAllConfirmItems ||
                _ctx.getRebuildItems.length === 0
                  ? _ctx.t("common.confirm")
                  : _ctx.t("orderRequest.confirmNewOrder")), 1)
              ], 8, _hoisted_73)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}